import type { SVGProps } from "react";
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M600.293 85.2929C600.683 84.9024 601.317 84.9024 601.707 85.2929L607.707 91.2929C608.098 91.6834 608.098 92.3166 607.707 92.7071L601.707 98.7071C601.317 99.0976 600.683 99.0976 600.293 98.7071C599.902 98.3166 599.902 97.6834 600.293 97.2929L605.586 92L600.293 86.7071C599.902 86.3166 599.902 85.6834 600.293 85.2929Z"
      fill="currentColor"
      transform="translate(-592 -80)"
    />
  </svg>
);
export default SvgChevronRight;
